<template>
  <div id="INIT">
    <div class="login-form-container">
      <img id="login-logo" src="static/images/logos/EW_LOGO.png">
      <v-alert
        color="error"
        icon="warning"
        transition="fade-transition"
        v-model="loginAlert">
        {{ getLoginError }}
        <v-icon @click="dismiss">clear</v-icon>
      </v-alert>
      <p v-if="pwForgot" class="pw-reset-msg">{{ $t("forgotten-password-msg") }}</p>
      <v-form v-model="valid" ref="loginForm" lazy-validation>
        <v-text-field
          color="success"
          :placeholder="$t('email')"
          v-model="email"
          :rules="emailRules" />
        <v-text-field
          v-if="!pwForgot"
          color="success"
          :placeholder="$t('password')"
          v-model="password"
          :rules="passwordRules"
          type="password" />
      </v-form>
      <button v-if="!pwForgot" class="login-button" @click="login">{{ $t('login') }}</button>
      <button v-if="pwForgot" class="login-button" @click="sendPassword">{{ $t('send') }}</button>
      <p class="forgot-password" v-if="!pwForgot" @click="pwForgot = true">{{ $t('forgot-password') }}</p>
      <p class="forgot-password" v-if="pwForgot" @click="pwForgot = false">{{ $t('login') }}</p>
    </div> 
    <!-- <v-container> -->
    <!-- LOGO -->
    <!-- <v-layout row wrap align-center>
            <v-flex xs12 class="text-xs-center" :style="{'margin-top': logoMargin}">
              <img src="static/images/logos/EW_LOGO.png" width="150">
            </v-flex>
          </v-layout> -->
    <!-- CODE INPUT -->
    <!-- <v-layout row wrap align-center>
        <v-flex xs3 />
        <v-flex xs6 class="font-number">
          <v-alert
            color="error"
            icon="warning"
            transition="fade-transition"
            @click="dismissAlert()"
            v-model="loginAlert">
            {{ $store.getters.getErrorMessage }}
          </v-alert>
          <v-text-field
            color="success"
            placeholder="e-Mail"
            v-model="email"
            :rules="[rules.emailRule]"
            hide-details />
          <v-text-field
            color="success"
            placeholder="Password"
            v-model="password"
            :append-icon="viewPasswordToggle ? 'visibility' : 'visibility_off'"
            :append-icon-cb="() => (viewPasswordToggle = !viewPasswordToggle)"
            :type="viewPasswordToggle ? 'password' : 'text'"
            counter
            maxlength="20"
            :rules="[rules.passRule]"
            hide-details />
          <v-text-field
            color="success"
            placeholder="P-ID"
            v-model="pidValue"
            :append-icon="viewPidToggle ? 'visibility' : 'visibility_off'"
            :append-icon-cb="() => (viewPidToggle = !viewPidToggle)"
            :type="viewPidToggle ? 'password' : 'text'"
            counter
            maxlength="8"
            :rules="[rules.playerID]"
            hide-details
            @keyup.enter="login" />
        </v-flex>
        <v-flex xs3 />
        <v-flex xs12 class="text-xs-center btnPOS">
          <v-btn
            color="success"
            fab
            large
            :disabled="!rules.playerID(pidValue)"
            @click.native="login()">
            <v-icon>done</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container> -->
  </div>
</template>

<script>
import { emailRules, passwordRules } from "../validation/rules";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      valid: true,
      email: "",
      password: "",
      pwForgot: false
    };
  },
  computed: {
    ...mapGetters(["getLoginError"]),
    loginAlert() {
      if (this.getLoginError) return true;
      return false;
    },
    emailRules: () => emailRules,
    passwordRules: () => passwordRules
  },
  methods: {
    ...mapActions(["loginUser", "dismissLoginAlert", "resetPassword"]),
    login() {
      if (this.$refs.loginForm.validate()) {
        this.loginUser({
          email: this.email,
          password: this.password
        });
      }
    },
    sendPassword() {
      if (this.$refs.loginForm.validate()) {
        this.resetPassword(this.email);
      }
    },
    dismiss() {
      this.dismissLoginAlert();
    },
    // login() {
    //   if (this.rules.emailRule && this.rules.passRule && this.rules.playerID) {
    //     this.$store.dispatch("connect", {
    //       email: this.email,
    //       password: this.password,
    //       pid: this.pidValue
    //     });
    //   }
    // }
  }
};
</script>

<style>
#INIT {
  background-color: black;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow: hidden !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-form-container {
  width: 300px;
  min-height: 300px;
  padding: 20px;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}

#login-logo {
  max-width: 200px;
}

.input-group {
  padding: 0;
}

.input-group__messages {
  margin: 0 auto;
}

.input-group--text-field input {
  font-size: 20px;
  text-align: center;
}

.input-group__input {
  height: 10px;
}

.login-button {
  background-color: #00aeef;
  padding: 8px 16px;
  margin: 20px 0;
  min-width: 150px;
  text-transform: uppercase;
  border-radius: 10px;
}
.login-button:hover {
  cursor: pointer;
}
.login-button:focus {
  outline: none;
}
.forgot-password {
  margin: 0;
  font-size: 14px;
}
.forgot-password:hover {
  cursor: pointer;
  color: #00aeef;
}
.pw-reset-msg {
  text-align: center;
}
/* .input-group--text-field input,
.input-group--text-field textarea {
  font-size: 55px;
  height: 65px;
  text-align: center;
} */

/* .input-group--text-field input {
  font-size: 50px;
} */

/* .input-group__details {
  min-height: 5px !important;
}

.input-group__details:before {
  height: 5px !important;
}

.input-group__details:after {
  height: 5px !important;
}

.input-group--text-field input,
.input-group--text-field textarea {
  font-size: 55px;
  height: 65px;
  text-align: center;
}

.btnPOS {
  margin-top: 60px;
} */
</style>





// WEBPACK FOOTER //
// src/components/Splash.vue